import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getDocuments } from "../../redux/actions/actionDocument";
import { format } from "date-fns";
import LoadingIcons from "react-loading-icons";

export default function DeleteDocFind() {
  const dispatch = useDispatch(); 
  const documents = useSelector((state) => state.documents.allDocuments);    
  const [docFind, setDocFind] = useState();

  useEffect(() => {
    dispatch(getDocuments());
  }, [dispatch]);
  console.log(documents);

  const documentsFilter =
    documents[0] !== undefined
      ? documents[0].filter((e) => e.state === false)
      : null;

  const handleChange = (e) => {
    const { value } = e.target;
    console.log(value);   
    filterDoc(value);
    console.log(docFind);
  };

  const filterDoc = (doc) => {
    console.log(doc);
    let result = documents[0].filter((e) => {
      if (e.state === false) {
        console.log(e)
        if (
          e.client_id.nameCompany
            .toString()
            .toLowerCase()
            .includes(doc.toLowerCase()) ||          
          e.numberDocument == doc
          //&& e.state === false
        ) {
          //console.log(e)
          return e;
        }
       }
    });
    setDocFind(result);
  };

  console.log(docFind);

  return (
    <div className="container bg-gray-900">
        <div className="m-5">
      <div className="text-xl pb-8 underline  text-orange-500">Borrado de Documento</div>
      <div className="h-20 bg-cyan-900">
            <div className="flex flex-row text-[12px] w-56 font-bold text-yellow-500 pt-1 pl-5">
            <p className="mr-2">Buscar</p>
            <input
              className="border border-slate-700 rounded w-44 h-4 text-center bg-cyan-600 placeholder-yellow-400"
              type="text"
              placeholder="N° Pedido / Nombre Cliente"
              onChange={handleChange}
              
            />
          </div>
          <div className="w-56 text-center">
            {/* <button className="w-16 ml-14 text-[10pt] font-bold text-yellow-500 hover:text-white hover:text-[11pt]" onClick={filterItem}>Buscar</button>
            <button className="w-16 h-6 ml-2 text-[10pt] font-bold text-yellow-500 hover:text-white hover:text-[11pt]" onClick={handleLimpiar}>Limpiar</button> */}
          </div>
            </div>      
      
      
      <div>
        <div className="flex text-[14px] font-bold text-orange-500">
          <p className="w-12 ">Doc N°</p>
          <p className="w-60 ">Nombre Cliente</p>
          <p className="w-5/12">Domicilio Evento</p>
          <p className="w-20">Fecha de Salida</p>
          <p className="w-20">Fecha de Entrada</p>
          <p className="w-20">Estado</p>
        </div>
        <div className="max-h-screen overflow-y-auto">
       {documentsFilter === null ? <div className="flex h-[400px] items-center justify-center"><LoadingIcons.Bars /></div> :
        docFind === undefined
          ? documentsFilter && documentsFilter.map((e) => {
              return (
                <div key={e._id} className="">                  
                    <Link to={`/documentos/delete/${e._id}`}>
                      <div className="flex text-[11px] hover:font-bold pt-2 text-sky-200 hover:text-orange-400 border-slate-500 border-b">
                        
                          <div className="w-12 text-center">
                            {e.numberDocument}
                          </div>
                          <div className="w-60">
                            {e.client_id.nameCompany}
                          </div>
                          <div className="w-5/12">
                            {e.client_id.address}
                          </div>                         
                          <div className="w-20 pl-2">
                            {e.dateSend ? format(new Date(e.dateSend), 'dd/MM/yyyy') : null}
                          </div>
                          <div className="w-20 pl-2">
                            {e.dateReception ? format(new Date(e.dateReception), 'dd/MM/yyyy') : null}
                          </div>
                          <div className="w-20 pl-2">
                            {e.state === false ? "No Saldado" : "Saldado"}
                          </div>
                        
                      </div>
                    </Link>
                </div>
              );
            })
          : docFind.map((e) => {
              return (
                <div key={e._id} className="">
                  <Link to={`/documentos/delete/${e._id}`}>
                    <div key={e._id} className="flex text-[11px] hover:font-bold pt-2 text-sky-200 hover:text-orange-400 border-slate-500 border-b">
                      
                        <div className="w-12 text-center">
                          {e.numberDocument}
                        </div>
                        <div className="w-60">
                          {e.client_id.nameCompany}
                        </div>
                        <div className="w-5/12">
                            {e.client_id.address}
                        </div>
                        <div className="w-20 pl-2">
                          {e.dateSend ? format(new Date (e.dateSend), 'dd/MM/yyyy') : null}
                        </div>
                        <div className="w-20 pl-2">
                          {e.dateReception ? format(new Date(e.dateReception), 'dd/MM/yyyy') : null}
                        </div>
                        <div className="w-20 pl-2">
                          {e.state === false ? "No Saldado" : "Saldado"}
                        </div>
                      
                    </div>
                  </Link>
                </div>
              );
            })}
            </div>
      </div>
      </div>
    </div>
  );
}
